module.exports = __webpack_public_path__ + "img/rjcStatement.7f2dc11.webp";